import Utilities from "../foundation/Utility";
import store, { resetStore } from "../state/Store";
import { setShareMenuOpen } from "../state/system/UIConfiguration";
import { ContextMenuItem } from "../types/system/ContextMenuItem";

const contextMenuData: ContextMenuItem[] = [
    {
        icon: "search",
        name: "Find",
        shortcut: "Ctrl+F",
        default: true,
        handler: () => alert("Search"),
        order: 0,
    },
    {
        icon: "refresh",
        name: "Refresh Display",
        shortcut: "F5",
        default: true,
        handler: async (_, context) => {
            await resetStore();
            // window.location.reload();
            context.refreshRoute();
        },
        order: 1,
    },
    {
        icon: "tune",
        name: "Display",
        shortcut: "F11",
        default: true,
        handler: () => alert("Display"),
        order: 2,
    },
    {
        separator: true,
        order: 3,
    },
    {
        icon: "cut",
        name: "Cut",
        shortcut: "Ctrl+X",
        default: true,
        handler: async (_, context) => {
            const target = context.getContextTarget();
            const selection = Utilities.applySelectionRange(
                target,
                context.getContextSelection(),
            );

            if (!selection) return;

            await navigator.clipboard.writeText(selection.toString());
            Utilities.removeSelection(target, selection);
        },
        disabledHandler: context => !context.hasTextSelection(),
        order: 4,
    },
    {
        icon: "content_copy",
        name: "Copy",
        shortcut: "Ctrl+C",
        default: true,
        handler: async (_, context) => {
            const selection = Utilities.applySelectionRange(
                context.getContextTarget(),
                context.getContextSelection(),
            );

            if (!selection) return;

            await navigator.clipboard.writeText(selection.toString());
        },
        disabledHandler: context => !context.hasTextSelection(),
        order: 5,
    },
    {
        icon: "content_paste",
        name: "Paste",
        shortcut: "Ctrl+V",
        default: true,
        handler: async (_, context) => {
            const target = (context.getContextTarget() ??
                document.activeElement) as HTMLInputElement;
            const pasteContent = await navigator.clipboard.readText();

            if (!target || !pasteContent) return;

            const currentValue = target.value?.toString() ?? "";
            const selectStart = target.selectionStart;
            const selectEnd = target.selectionEnd;

            target.value = currentValue
                .substring(0, selectStart)
                .concat(pasteContent)
                .concat(currentValue.substring(selectEnd));

            target.selectionStart = selectStart + pasteContent.length;
            target.selectionEnd = target.selectionStart;
        },
        disabledHandler: context =>
            !navigator.clipboard || !context.isEditable(),
        order: 6,
    },
    {
        separator: true,
        order: 7,
    },
    {
        icon: "ios_share",
        name: "Share",
        shortcut: "Ctrl+P",
        handler: () => store.dispatch(setShareMenuOpen(true)),
        order: 8,
    },
];

export default contextMenuData;
